import { render, staticRenderFns } from "./articleComponent.vue?vue&type=template&id=ca688c9e&scoped=true&"
import script from "./articleComponent.vue?vue&type=script&lang=js&"
export * from "./articleComponent.vue?vue&type=script&lang=js&"
import style0 from "./articleComponent.vue?vue&type=style&index=0&id=ca688c9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca688c9e",
  null
  
)

export default component.exports